import { render, staticRenderFns } from "./IconWarningSmall.vue?vue&type=template&id=1959d191&"
import script from "./IconWarningSmall.vue?vue&type=script&lang=js&"
export * from "./IconWarningSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1959d191')) {
      api.createRecord('1959d191', component.options)
    } else {
      api.reload('1959d191', component.options)
    }
    module.hot.accept("./IconWarningSmall.vue?vue&type=template&id=1959d191&", function () {
      api.rerender('1959d191', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconWarningSmall.vue"
export default component.exports